import { View } from "react-native";
import { Text } from "@shared/components/text";

export const SectionHeading = ({ title, count }: { title: string; count?: string }) => (
    <View className="flex-row items-center gap-4">
        <Text className="font-heading text-lg text-black">{title}</Text>
        <View className="flex-1 border-t border-gray-400" />
        {!!count && <Text className="text-md font-semibold text-gray-500">{count}</Text>}
    </View>
);

export default SectionHeading;
